import { useEffect, useState } from "react";
import { api } from "../lib/config";
import { Sun, Sunrise, CalendarRange, TrendingUp, CalendarDays } from "lucide-react";

const Stat = ({ Icon, label, value, sublabel, tone = "default", testid }) => {
  const tones = {
    default: "bg-white text-gray-900 border-gray-200",
    emerald: "bg-gradient-to-br from-[#0A2E1E] to-[#062818] text-white border-transparent",
    amber:   "bg-amber-50 text-amber-900 border-amber-200",
    sky:     "bg-sky-50 text-sky-900 border-sky-200",
    rose:    "bg-rose-50 text-rose-900 border-rose-200",
  };
  return (
    <div data-testid={testid} className={`rounded-2xl border p-4 ${tones[tone]}`}>
      <div className="flex items-center justify-between">
        <div className={`text-[10px] uppercase tracking-[0.18em] font-extrabold ${tone === "emerald" ? "text-emerald-200" : "text-gray-500"}`}>{label}</div>
        <Icon className={`w-4 h-4 ${tone === "emerald" ? "text-emerald-300" : "text-[#047857]"}`} />
      </div>
      <div className={`mt-1 text-2xl font-extrabold tabular-nums font-[Outfit] tracking-tight`}>{value}</div>
      {sublabel && <div className={`text-[11px] ${tone === "emerald" ? "text-emerald-200/80" : "text-gray-500"}`}>{sublabel}</div>}
    </div>
  );
};

export default function DashboardSummary() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    api.get("/admin/summary").then(({ data }) => { if (active) setData(data); }).catch(() => {});
    return () => { active = false; };
  }, []);

  const d = data || {};
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="dashboard-summary">
      <Stat Icon={Sun}           label="Today's Jobs"     value={d.today?.count ?? "—"}            sublabel={d.today?.date}        tone="emerald" testid="stat-today" />
      <Stat Icon={Sunrise}       label="Tomorrow's Jobs"  value={d.tomorrow?.count ?? "—"}         sublabel={d.tomorrow?.date}     testid="stat-tomorrow" />
      <Stat Icon={TrendingUp}    label="This Week"        value={`$${(d.week_revenue ?? 0).toFixed(0)}`}  sublabel="Completed revenue" tone="sky"   testid="stat-week-revenue" />
      <Stat Icon={CalendarRange} label="This Month"       value={`$${(d.month_revenue ?? 0).toFixed(0)}`} sublabel={`Forecast $${(d.month_forecast ?? 0).toFixed(0)}`} tone="amber" testid="stat-month-revenue" />
      <Stat Icon={CalendarDays}  label="Upcoming"         value={d.upcoming_count ?? "—"}          sublabel="scheduled appts"      testid="stat-upcoming" />
    </div>
  );
}
